import { getMenuRouter } from "@/utils/MenuUtil";

export default {
  routerList: [
    ...getMenuRouter(),
    {
      path: "/Home",
      component: () => import("@/views/HomeView.vue"),
      name: "Home",
      meta: {
        title: "HiTRUST｜金流支付與資訊安全解決方案",
        description:
          "網威智慧 HiTRUST 提供業界領先的全方位金流支付（信用卡、行動支付、Shopify跨境電商、方便付）與智慧資安防詐（VeriFido無密碼驗證、Veri-id AI防詐、3-D Secure驗證與數位憑證）解決方案。",
        keywords:
          "HiTRUST, 網威智慧, HiTRUSTpay, 金流支付, 跨境金流, Shopify金流, 行動支付, 信用卡收款, 3D驗證, VeriFido, Veri-id, 資安防詐",
        priority: "1.0",
        changefreq: "daily",
      },
    },
    {
      path: "/ContactUs",
      component: () => import("@/views/ContactUsView.vue"),
      name: "ContactUs",
      meta: {
        title: "聯絡我們",
        description:
          "若您有金流串接、跨境電商收單、VeriFido 無密碼驗證、Veri-id AI 防詐等業務合作需求或任何問題，歡迎隨時與網威智慧 (HiTRUST) 專業顧問團隊聯繫。",
        keywords: "網威智慧聯絡方式, HiTRUST客服, 金流諮詢, 資安諮詢, 業務合作",
        priority: "0.8",
        changefreq: "monthly",
      },
    },
  ],
};
